if (!customElements.get('load-more')) {
  class LoadMore extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      const target = event.target.closest('[js-load-more]');

      if (!target) return;

      event.preventDefault();

      fetch(target.getAttribute('href') + '&sections=main-collection')
        .then((res) => res.json())
        .then((data) => {
          const html = new DOMParser().parseFromString(
            data['main-collection'],
            'text/html',
          );

          const button = html.querySelector('[js-load-more]');
          const grid = html.querySelector('[js-load-target]');

          if (!button) {
            target.parentElement.removeChild(target);
          } else {
            target.outerHTML = button.outerHTML;
          }

          if (!grid) return;

          this.grid.innerHTML = this.grid.innerHTML + grid.innerHTML;
        })
        .catch((error) => console.log(error));
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);

      this.grid = this.querySelector('[js-load-target]');
    }
  }

  customElements.define('load-more', LoadMore);
}
